// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUi from 'element-ui'
import echarts from 'echarts'
import axios from 'axios'
import * as filters from './filters'
import common from './common/common'
import vueswiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import CryptoJS from "crypto-js"
import dataV from '@jiaminghi/data-view'
// import BaiduMap from 'vue-baidu-map'

// var root = process.env.API_ROOT;
import '@/assets/css/reset.css'
import '@/theme-et/index.css'
import '@/assets/scss/element-variables.scss'
import '@/assets/css/common.min.css'
import '../static/iconfont.css'
//注册使用
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));

Vue.prototype.$echarts = echarts
Vue.prototype.$http = axios
Vue.prototype.$crypto = CryptoJS

Vue.use(common)
Vue.use(vueswiper)
Vue.use(ElementUi)
Vue.use(dataV)
// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 
//   ak: 'YywcSrDX7bUbjv9ZvRorT6kkOso9ejwG'
// })
//阻止启动生产消息，控制台少生成一段
Vue.config.productionTip = false

// const CancelToken = axios.CancelToken;
// const source = CancelToken.source();


/* eslint-disable no-new */
//拦截器要放在实例下面，否则刷新时候获取不到拦截器
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js